export default "__VITE_ASSET__BgQE8qhb__"